import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import packageInfo from '../../../package.json';
import './branding.css';

export function ProductLogo({ width = 190 }) {
	return <div className="apworks-logo" role="img" aria-label="APWorks" style={{ width, height: width * 220 / 800, '--apworks-logo-image': "url('/images/apworks-logo.png')" }}>
		<img src="/images/apworks-logo.png" alt="" />
	</div>;
}

export function NexelusEndorsement() {
	return <div className="apworks-endorsement"><span>A product of</span><img src="/images/nexelus-logo-200.png" alt="Nexelus" /></div>;
}

export function ProductLockup() {
	return <div className="apworks-lockup"><ProductLogo width={235} /><NexelusEndorsement /></div>;
}

// Client-provided branding is separate from the product logo. Suppress only the old bundled defaults.
export function isDefaultProductLogo(src) {
	if (!src) return true;
	return /(?:^|\/)nexelus-logo-200(?:_white(?:_test)?)?\.png(?:[?#].*)?$/i.test(src);
}

export function AboutAPWorks({ open, onClose }) {
	return <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth aria-labelledby="apworks-about-title" PaperProps={{ className: 'apworks-about' }}>
		<DialogTitle id="apworks-about-title">About APWorks</DialogTitle>
		<DialogContent>
			<ProductLockup />
			<dl><dt>Version</dt><dd>{packageInfo.version}</dd><dt>Support</dt><dd>Contact your administrator for support access.</dd></dl>
			<p className="apworks-legal">Copyright 1993–{new Date().getFullYear()} Paradigm Software Technologies. All rights reserved.</p>
		</DialogContent>
		<DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
	</Dialog>;
}
